<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">微信聊天</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">微信菜单</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <a-button @click="addkf" type="primary">添加父级菜单</a-button>
                <a-button type="danger" :disabled="disabled" @click="delusers">删除菜单</a-button>
                <a-button @click="create" type="primary">生成微信菜单</a-button>
            </div>
            <!-- 来源 -->

            <div class="right">
                <a-input-search
                    :placeholder="tstext"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                >
                </a-input-search>
            </div>
             
        </div>
       <!--  -->
        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table :row-selection="{ onChange: onSelectChange}" 
                :childrenColumnName="sub_button"
                :expanded-row-keys.sync="expandedRowKeys"  rowKey="wmid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
                    <span slot="action" slot-scope="text,record" class="operate">
                        <!-- <a href="javascript:;" @click="toedit(record.id)" style="margin-right:12px"><a-icon type="edit" /> 跟进</a> -->
                        <a href="javascript:;" v-if="record.pwmid==0" @click="addckf(record.wmid)"><a-icon type="edit" /> 添加菜单</a>
                        <a href="javascript:;" @click="edituser(record.wmid)"><a-icon type="edit" /> 编辑</a>
                        <a href="javascript:;" @click="deluser(record.wmid)"><a-icon type="delete" /> 删除</a>
                    </span>

                    <span slot="type" slot-scope="text">
                        <span v-if="text==0">主菜单</span>
                        <span v-if="text==1">链接</span>
                        <span v-if="text==2">触发关键字</span>
                        <span v-if="text==3">小程序</span>
                    </span>
                    <!-- <span slot="id" slot-scope="text,record">
                        <span v-if="record.pwmid!=0"></span><span>{{text}}</span> 
                    </span>-->

                    <span slot="menu" slot-scope="text,record">
                        <span v-if="record.pwmid!=0"><a-icon type="align-left" /></span> {{text}}
                    </span> 
                    <!-- <span slot="menuaction" slot-scope="text,record">
                        <a href="javascript:;" @click="menuset(record.id)"><a-icon type="setting" /> 设置菜单动作</a>
                    </span> -->

                    <span slot="status" slot-scope="text,record">
                        <!-- {{text}} -->
                        <a-switch checked-children="显示" un-checked-children="隐藏" :checked="text" @change="checked => onstatusChange(checked,record.id)"/>
                    </span>

                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>


                </a-table>

            </a-spin>
        </div>

        <!-- 添加菜单 -->
        <a-modal
        title="添加菜单"
        :visible="addvisible"
        cancelText="取消"
        okText="确认"
        @ok="addhandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="菜单层级">
                    <a-input v-model="pwmid"  disabled />
                </a-form-item>
                <a-form-item label="菜单名称">
                    <a-input v-model="title" placeholder=""  v-decorator="['菜单名称', { rules: [{ required: true, message: '请输入菜单名称' }] }]" />
                </a-form-item>
                <a-form-item label="动作类型">
                    <a-select style="width: 120px;margin-left:12px" v-model="type" allowClear @change="typehandleChange" placeholder="动作类型" :showArrow="show">
                        <a-select-option v-for="(option,x) in typeoption" :key="x" :value="option.id">
                            {{option.name}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item v-if="urlshow" label="链接">
                    <a-input v-model="href" />
                </a-form-item>
                <a-form-item v-if="xcxshow" label="链接">
                    <a-input v-model="href" />
                </a-form-item>
                <a-form-item v-if="xcxshow" label="小程序appid">
                    <a-input v-model="appid" />
                </a-form-item>
                <a-form-item v-if="xcxshow" label="小程序路径">
                    <a-input v-model="pagepath" />
                </a-form-item>
                <a-form-item v-if="keyshow" label="关键字">
                     <a-select style="width: 120px;margin-left:12px" v-model="keyword" allowClear @change="clickhandleChange" placeholder="动作类型" :showArrow="show">
                        <a-select-option v-for="(option,x) in clickoption" :key="x" :value="option.arid">
                            {{option.title}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                 <!-- <a-form-item v-if="keyshow" label="关键字">
                    <a-input v-model="keyword" />
                </a-form-item> -->
                <a-form-item label="排序">
                    <a-input v-model="sort"  placeholder="数字越小越靠前"/>
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- 编辑菜单 -->
        <a-modal
        title="编辑菜单"
        :visible="editvisible"
        cancelText="取消"
        okText="确认"
        @ok="edithandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">

                <a-form-item label="菜单层级">
                    <a-input v-model="editinfo.pwmid"   />
                </a-form-item>
                <a-form-item label="菜单名称">
                    <a-input v-model="editinfo.title" placeholder=""   />
                </a-form-item>
                <a-form-item label="动作类型">
                    <a-select style="width: 120px;margin-left:12px" v-model="editinfo.type" allowClear @change="oneditChange" placeholder="动作类型" :showArrow="show">
                        <a-select-option v-for="(option,x) in typeoption" :key="x" :value="option.id">
                            {{option.name}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item v-if="urlshow" label="链接">
                    <a-input v-model="editinfo.href" />
                </a-form-item>
                <a-form-item v-if="xcxshow" label="链接">
                    <a-input v-model="editinfo.href" />
                </a-form-item>
                <a-form-item v-if="xcxshow" label="小程序appid">
                    <a-input v-model="editinfo.appid" />
                </a-form-item>
                <a-form-item v-if="xcxshow" label="小程序路径">
                    <a-input v-model="editinfo.pagepath" />
                </a-form-item>
                <a-form-item v-if="keyshow" label="关键字">
                     <a-select style="width: 120px;margin-left:12px" v-model="editinfo.keyword" allowClear @change="clickeditChange" placeholder="动作类型" :showArrow="show">
                        <a-select-option v-for="(option,x) in clickoption" :key="x" :value="option.arid">
                            {{option.title}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                 <!-- <a-form-item v-if="keyshow" label="关键字">
                    <a-input v-model="editinfo.keyword" />
                </a-form-item> -->
                <a-form-item label="排序">
                    <a-input v-model="editinfo.sort"  />
                </a-form-item>
                <!--<a-form-item label="是否显示">
                    <a-switch checked-children="显示" un-checked-children="隐藏" :defaultChecked="defaultc" @change="oneditChange"/>
                </a-form-item> -->
            </a-form>
        </a-modal>


        <!-- 设置菜单动作 -->
         <!-- <a-modal
        title="编辑菜单"
        :visible="setvisible"
        cancelText="取消"
        okText="确认"
        @ok="sethandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
               
                <a-form-item label="链接地址">
                    <a-input v-model="href_api"   />
                </a-form-item>
                <a-form-item label="APPID">
                    <a-input v-model="href_api" placeholder=""   />
                </a-form-item>
                <a-form-item label="PAGEPATH">
                    <a-input v-model="href_api"  />
                </a-form-item>

            </a-form>
        </a-modal> -->
    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import { Modal } from 'ant-design-vue';

const columns = [
    {title: '排序',dataIndex: 'sort',key: 'sort',width:100},
    // {title: 'ID',dataIndex: 'wmid',key: 'wmid',width:90,scopedSlots: { customRender: 'id' }},
    {title: '菜单名称',dataIndex: 'name',key: 'name',width:250,scopedSlots: { customRender: 'menu' }},
    // {title: '菜单设置',key: 'menuaction',scopedSlots: { customRender: 'menuaction' },width:280},
    {title: '类型',dataIndex: 'type',key: 'type',width:150,scopedSlots: { customRender: 'type' }},
    // {title: 'url地址',dataIndex: 'url',key: 'url',width:'280px'},
    // {title: 'appid',dataIndex: 'appid',key: 'appid',width:'180px'},
    // {title: 'pagepath',dataIndex: 'pagepath',key: 'pagepath',width:'180px'},
    // {title: '关键词',dataIndex: 'key_title',key: 'key_title',width:'90px'},
    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' },width:260,fixed: 'right'},
];

export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
    data(){
        return{
            columns,
            data:[],
            tablespinning:true,
            pageSizeOptions:['10','20','30','40','100','200'],
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            addvisible:false,
            editvisible:false,
            tstext:"菜单",

            searchtext:"",
            form: this.$form.createForm(this, { name: 'coordinated' }),
            username:"",

            expandedRowKeys:[],

            title:"",
            // menu_status:1,
            sort:"",
            href:"",
            pwmid:0,
            pagepath:"",
            type:0,
            appid:"",
            keyword:"",
            clickoption:"",

            tablex:"100%",
            delids:[],
            disabled:true,
            editinfo:{type:'',pwmid:""},
            editid:"",
            defaultc:"",
            href_api:"",

            true:true,
            false:false,
            setvisible:false,

            typeoption:[{id:0,name:"主菜单"},{id:1,name:"链接"},{id:2,name:"触发关键字"},{id:3,name:"小程序"}],
            imid:"",
            sub_button:"sub_button",

            urlshow:false,
            keyshow:false,
            xcxshow:false,

            show:true,
        }
    },
    watch: {
      windowHeight (val) {
        this.tabley=val*0.56
      },
    },

    mounted(){
        this.personinfo()
        this.getclicklist()
        // this.fetch()
        this.tablespinning=false

    },
    methods:{
        clickhandleChange(value){
            this.keyword=value
        },
        clickeditChange(value){
            this.editinfo.keyword=value
        },

         getclicklist(){
            this.$axios.post('/api/wechat1/autoreplylist',{
                pagesize: 50,
                type:4
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                   this.clickoption=res.data.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

    // 生成菜单
    create(){
        this.$axios.post('/api/wechat1/createmenu',{
            imid:this.imid
        },{
            headers: {
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.errcode==0){
                this.$message.success("生成成功"); 
            }else{
                this.$message.warning(res.data.errmsg); 
            }
            
        })
    },

    personinfo(){
        this.$axios.post('/api/system/adminpage',{
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                this.imid=res.data.data.imid
                this.fetch()
                }else{
                this.$message.warning(res.data.msg); 
                }
                
            })
        },

        // 菜单设置
        menuset(){
            this.setvisible=true
        },
        typehandleChange(value){
            this.type=value
            if(value==0){
                this.xcxshow=false,
                this.keyshow=false,
                this.urlshow=false
            }else if(value==1){
                this.xcxshow=false,
                this.keyshow=false,
                this.urlshow=true
            }else if(value==2){
                this.xcxshow=false,
                this.keyshow=true,
                this.urlshow=false
            }else if(value==3){
                this.xcxshow=true,
                this.keyshow=false,
                this.urlshow=false
            }
        },
        onChange(checked){
            if(checked){
                this.menu_status=1
            }else{
                this.menu_status=0
            }
        },
        oneditChange(value){
            this.editinfo.type=value
             if(value==0){
                this.xcxshow=false,
                this.keyshow=false,
                this.urlshow=false
            }else if(value==1){
                this.xcxshow=false,
                this.keyshow=false,
                this.urlshow=true
            }else if(value==2){
                this.xcxshow=false,
                this.keyshow=true,
                this.urlshow=false
            }else if(value==3){
                this.xcxshow=true,
                this.keyshow=false,
                this.urlshow=false
            }
        },

        // 搜索
        onSearch(){

        },

        // 删除
        onSelectChange(selectedRowKeys){
            if(selectedRowKeys.length>0){
                this.disabled=false
            }else{
                this.disabled=true
            }
            this.delids=selectedRowKeys
            // console.log('selectedRowKeys changed: ', selectedRowKeys);
        },
        delusers(){
            var id=this.delids.join(",")
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        deluser(id){
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        handok(id){
            this.$axios.post('/api/wechat1/delwxmenu',{
                wmids:id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.disabled=true
                    this.$message.success('删除成功');
                    this.fetch()
                    this.getmymenu()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },


        // 编辑
        edituser(id){
            this.editid=id
            this.$axios.post('/api/wechat1/wxmenupage',{
                wmid:id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.editinfo=res.data.data
                    if(res.data.data.type==0){
                        this.xcxshow=false,
                        this.keyshow=false,
                        this.urlshow=false
                    }else if(res.data.data.type==1){
                        this.xcxshow=false,
                        this.keyshow=false,
                        this.urlshow=true
                    }else if(res.data.data.type==2){
                        this.xcxshow=false,
                        this.keyshow=true,
                        this.urlshow=false
                    }else if(res.data.data.type==3){
                        this.xcxshow=true,
                        this.keyshow=false,
                        this.urlshow=false
                    }
                    this.editvisible=true
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        edithandleOk(){
            this.$axios.post('/api/wechat1/editwxmenu',{
                wmid:this.editid,
                title: this.editinfo.title,
                pwmid:this.editinfo.pwmid,
                type:this.editinfo.type,
                sort:this.editinfo.sort,
                href:this.editinfo.href,
                appid:this.editinfo.appid,
                pagepath:this.editinfo.pagepath,
                keyword:this.editinfo.keyword,
                imid:this.imid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                    this.editvisible=false
                    this.fetch()
                    // this.getmymenu()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        // 添加菜单
        addkf(){
            this.pwmid=0
             this.addvisible=true
        },

        addckf(id){
            this.pwmid=id
            this.addvisible=true
        },
        addhandleOk(){
            this.$axios.post('/api/wechat1/addwxmenu',{
                title: this.title,
                pwmid:this.pwmid,
                type:this.type,
                sort:this.sort,
                href:this.href,
                appid:this.appid,
                pagepath:this.pagepath,
                keyword:this.keyword,
                imid:this.imid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.addvisible=false
                    this.$message.success(res.data.msg); 
                    this.title=""
                    this.type=""
                    this.sort=""
                    this.href=""
                    this.appid=""
                    this.pagepath=""
                    this.keyword=""
                    this.fetch()
                    // this.getmymenu()
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        handleCancel(){
            this.addvisible=false
            this.editvisible=false
            this.setvisible=this.false
        },
        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 数据
        fetch(params = {}){
            this.$axios.post('/api/wechat1/wxmenulist',{
                imid: this.imid,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var data=res.data.data
                    for(var i in data){
                        if(data[i].menu_status==0){
                            data[i].menu_status=false
                        }else{
                            data[i].menu_status=true
                        }
                    }
                    this.tablespinning=false
                    this.data=data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/chat/wxmenu.vue